import { render, staticRenderFns } from "./ServicePointDetailLastTransactions.vue?vue&type=template&id=58e320cc&scoped=true&"
import script from "./ServicePointDetailLastTransactions.vue?vue&type=script&lang=ts&"
export * from "./ServicePointDetailLastTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointDetailLastTransactions.vue?vue&type=style&index=0&id=58e320cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e320cc",
  null
  
)

export default component.exports